import Loading from '../../ui/Loading';
import ErrorMessage from '../../ui/ErrorMessage';
import EmptyData from '../../ui/EmptyData';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsFetching, setTypeOfShowModalType } from '../../../features/modal/modalSlice';
import { useState } from 'react';
import { useMasterData } from '../../../hooks/api/useMasterData';
import { usePackageSocket } from '../../../hooks/socket/usePackageSocket';
import PackageGroup from './PackageGroup';
import { usePackageListUseMemo } from '../../../hooks/use-memo/usePackageListUseMemo';
import { selectCurrentUserRole } from '../../../features/auth/authSlice';
import { isAdmin, isSuperAdmin } from '../../../utils/roleUtils';

interface PackageListProps {
    sortOption?: string;
    typeOfUser?: 'admin' | 'user' ;
}

export default function PackageList({ typeOfUser }: PackageListProps) {

    const { isLoadingGetBasicPackage, allPackages, isErrorAllPackages, isLoadingAllPackages, errorMessageAllPackages, } = useMasterData();
    usePackageSocket()
    const dispatch = useDispatch()
    const [search, setSearch] = useState("");
    const isFetching = useSelector(selectIsFetching);
    const isCurrentlyLoading = isLoadingAllPackages || isLoadingGetBasicPackage || isFetching;
    const { orderedGroupedPackages, filteredPackages } = usePackageListUseMemo({ allPackages, search })
    const role = useSelector(selectCurrentUserRole)
    const hasPermission = isSuperAdmin(role) || isAdmin(role)
    return (
        <>
            {hasPermission && (
                <div className="flex flex-col gap-2 lg:flex-row lg:items-end lg:justify-between">
                    <div className="flex items-end gap-2">
                        <button onClick={() => {
                            // dispatch(setTypeModal('newPackage'));
                            dispatch(setTypeOfShowModalType('newPackageModal'));
                        }} className="h-7 rounded bg-blue-600 px-3 text-xs font-medium text-white hover:bg-blue-700">
                            Add New
                        </button>
                        <input
                            type="text"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            placeholder="Search package..."
                            className="h-7 w-[280px] rounded border border-gray-300 px-3 text-xs shadow-sm outline-none placeholder:text-gray-400 focus:border-black"
                        />
                    </div>
                </div>
            )}
            <div className='overflow-hidden h-full rounded'>
                <div className='pr-0.5 h-full rounded overflow-y-auto'>
                    {isCurrentlyLoading ? (
                        <Loading message={'Loading package...'} />
                    ) : isErrorAllPackages ? (
                        <div className='h-full w-full flex items-center justify-center'>
                            <ErrorMessage message={errorMessageAllPackages} />
                        </div>
                    ) : filteredPackages.length === 0 ? (
                        <EmptyData message="No package available." />
                    ) : (
                        <PackageGroup
                            groupedPackages={orderedGroupedPackages}
                            typeOfUser={typeOfUser}
                        />
                    )}
                </div>
            </div>
        </>
    )
}
